module.exports = __webpack_public_path__ + "static/media/facebook.dc6606b5.svg";